<template>
    <form class="row cDetails g-3" v-on:submit.prevent="SubmitContactDetails">
        <template v-if="this.submitSuccess">
            <div class="col-12">
                <span class="success">{{this.contactUsSuccess}}</span>
            </div>
        </template>
        <template v-if="this.submitFailure">
            <div class="col-12">
                <span class="failure">{{this.inputFormSubmitFailure}}</span>
            </div>
        </template>
        <div class="row" v-if="!this.submitSuccess">
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       id="fname"
                       placeholder=" "
                       v-model="v$.leadObj.firstName.$model"
                       @blur="v$.leadObj.firstName.$touch()" />
                <label for="fname" class="form-label">{{formLabel.firstName}}</label>
                <template v-if="v$.leadObj.firstName.$error">
                    <span v-for="(err, index) in v$.leadObj.firstName.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       id="lname"
                       placeholder=" "
                       v-model="v$.leadObj.lastName.$model"
                       @blur="v$.leadObj.lastName.$touch()" />
                <label for="lname" class="form-label">{{formLabel.lastName}}</label>
                <template v-if="v$.leadObj.lastName.$error">
                    <span v-for="(err, index) in v$.leadObj.lastName.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-6">
                <input type="email"
                       class="form-control"
                       id="email"
                       placeholder=" "
                       v-model="v$.leadObj.email.$model"
                       @blur="v$.leadObj.email.$touch()" />
                <label for="email" class="form-label">{{formLabel.email}}</label>
                <template v-if="v$.leadObj.email.$error">
                    <span v-for="(err, index) in v$.leadObj.email.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-6">
                <input type="tel"
                       class="form-control"
                       id="phone"
                       placeholder=" "
                       v-model="leadObj.phone" />
                <label for="phone" class="form-label">{{formLabel.phone}}</label>
            </div>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       id="address"
                       placeholder=" "
                       v-model="leadObj.street" />
                <label for="address" class="form-label">{{formLabel.streetAddress}}</label>
            </div>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       id="serialNo"
                       placeholder=" "
                       v-model="leadObj.boat_serial_number__c" />
                <label for="serialNo" class="form-label">{{formLabel.boatSerial}}</label>
            </div>
            <div class="col-md-6">
                <div class="container p-0">
                    <div class="row">
                        <div class="col-md-12">
                            <input type="text"
                                   class="form-control"
                                   id="city"
                                   placeholder=" "
                                   v-model="leadObj.city" />
                            <label for="city" class="form-label">{{formLabel.city}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <states-dropdown :CountryCode="this.country"
                                   :onchange="selectedState"
                                   v-model="state"
                                   id="state" />
                            <label for="state" class="form-label">{{formLabel.state}}</label>
                        </div>
                        <div class="col-md-6">
                            <input type="text"
                                   class="form-control"
                                   id="zipcode"
                                   placeholder=" "
                                   v-model="leadObj.postalCode" />
                            <label for="zipcode" class="form-label">{{formLabel.zipcode}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <country-dropdown :v-model="this.country"
                                     :oncountryload="InitialSelect"
                                     :onchange="selectedCountry"
                                     id="country" />
                            <label for="country" class="form-label">{{formLabel.country}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <textarea type="text"
                          class="form-control form-textarea"
                          rows="6"
                          id="message"
                          placeholder=" "
                          v-model="v$.leadObj.comments__c.$model"
                          @blur="v$.leadObj.comments__c.$touch()" />
                <label for="message" class="form-label">{{formLabel.message}}</label>
                <template v-if="v$.leadObj.comments__c.$error">
                    <span v-for="(err, index) in v$.leadObj.comments__c.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-12 submission">
                <button type="submit" class="btn-submit" :disabled="isSubmitting">{{formLabel.submit}}</button>
            </div>
            <div class="hidden">
                <input type="hidden"
                       id="CONTACT_US_LEAD_SOURCE"
                       name="CONTACT_US_LEAD_SOURCE"
                       v-model="leadSource" />
                <input type="hidden"
                       id="loading-time"
                       name="loading-time"
                       :value="this.unixTimestamp" />
                <input type="text"
                       style="display: none"
                       id="hpValue"
                       name="hpValue"
                       v-model="hpvalue" />
            </div>
        </div>
    </form>
</template>
<script>
    import CountryDropdown from "../atoms/CountryDropdown.vue";
    import StatesDropdown from "../atoms/StatesDropdown.vue";
    import getEndPoint, { leadAPI } from "../../constants/api.config";
    import { salesforcelead } from "../../constants/form-model-config";
    import useValidate from "@vuelidate/core";
    import { required, email, helpers } from "@vuelidate/validators";
    import {inputFormSubmitFailure, contactUsSuccess, formLabel} from '../../constants/labels.config'

    export default {
        name: "ContactDetails",
        components: {
            CountryDropdown,
            StatesDropdown,
        },
        data() {
            return {
                v$: useValidate(),
                state: "",
                country: "",
                leadSource: "contact us",
                hpvalue: "",
                requestTime: "",
                leadID: "",
                leadObj: { ...salesforcelead },
                submitSuccess: false,
                submitFailure: false,
                inputFormSubmitFailure,
                contactUsSuccess,
                isSubmitting:null,
                formLabel
            };
        },
        validations() {
            return {
                leadObj:{
                    firstName: {
                        required: helpers.withMessage("First name cannot be empty", required),
                    },
                    lastName: {
                        required: helpers.withMessage("Last name cannot be empty", required),
                    },
                    email: {
                        required: helpers.withMessage(
                            "Email address cannot be empty",
                            required
                        ),
                        email: helpers.withMessage("Invalid email address", email),
                    },
                    comments__c: {
                        required: helpers.withMessage("Message cannot be empty", required),
                    },
                }
            };
        },
        computed: {
            unixTimestamp: function () {
                return Math.round(new Date().getTime() / 1000);
            },
        },
        methods: {
            SubmitContactDetails(e) {
                this.submitSuccess = false;
                this.submitFailure = false;
                this.isSubmitting=true;
                this.v$.$validate();
                if (this.v$.$error) {                    
                    this.isSubmitting=false;
                    for (var i = 0; i < this.v$.$errors.length; i++) {
                        console.log(this.v$.$errors[i].$message);
                    }
                    return;
                }

                this.leadObj.state = this.state != "" ? this.state : document.getElementById("state").value;
                this.leadObj.country = this.country;
                this.leadObj.leadSource = this.leadSource;
                this.leadObj.honeyPot = this.hpvalue;
                this.leadObj.requestTime = document.getElementById("loading-time").value;
                console.log(this.leadObj);
                this.axios
                    .post(getEndPoint(leadAPI), this.leadObj)
                    .then((response) => {
                        this.leadID = response.data.id;
                        this.submitSuccess = true;
                        this.submitFailure = false;
                        this.isSubmitting = false;
                    })
                    .catch((error) => {
                        this.submitFailure = true;
                        this.submitSuccess = false;
                        this.isSubmitting = false;
                        console.error("There was an error!", error);
                    });
                e.preventDefault();
            },
            selectedCountry: function (event) {
                this.country = event.target.value;
            },
            selectedState: function (event) {
                this.state = event.target.value;
            },
            InitialSelect: function (data) {
                this.country = data;
            },
        },
    };
</script>
